<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong class="black--text">Contact</strong>
      </div>
      <ContactDialog :pro="pro" />
    </template>

    <Item icon="mdi-account">{{ pro.contact_name }}</Item>
    <Item icon="mdi-phone">{{ pro.phone }} (leads)</Item>
    <Item icon="mdi-email">{{ pro.email }}</Item>
  </Section>
</template>

<script>
  import { Item, Section } from '@/components/pages'

  import ContactDialog from '../dialogs/ContactDialog'

  export default {
    components: { Section, Item, ContactDialog },

    props: ['pro'],
  }
</script>